import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDataCourse } from 'store/modules/course_store/actions';
import IntroductionSession from 'components/organisms/introduction_session';
import DashboardSession from 'components/organisms/dashboard_session';
import OpportunitiesSession from 'components/organisms/opportunities_session';
import ManagedBiddingsSession from 'components/molecules/managed_biddings_session';
import { biddingsOverview } from 'store/modules/bidding_store/actions';
import { BiddingTypes } from 'store/modules/bidding_store/types';
import { ProfileState, ProfileTypes } from 'store/modules/profile_store/types';
import { refreshProfile } from 'store/modules/profile_store/actions';
import companyId from 'services/company_id';
import ModalBidWinner from 'components/atoms/modal_bid_winner';
import FlashMessageNotification from 'components/molecules/flash-message-notification';
import { getFlashMessageNotifications } from 'store/modules/flash_message_notification_store/actions';
import {
  getMonitoredElectronicTradingIds,
  // getTradingKeywords,
} from 'store/modules/monitoring_store/actions';
import ExpirationAlert from 'components/molecules/expiration_alert';
import { getUserContacts } from 'store/modules/user_contacts_store/actions';
import EvaluationSession from 'components/molecules/evaluation_session';
import { ApplicationState } from 'store';
import { PanelState } from 'store/modules/panel_store/types';
import BannerRenewalPanel from 'components/molecules/banner_renewal_panel';
import TopBannerInSample from 'components/molecules/top_banner_in_sample';
import ModalWelcomeIaml from 'components/atoms/modal_welcome_iaml';
import { GetImmminence } from 'store/modules/get_dados_imminence_store/actions';
import { getLastClass } from 'store/modules/progression_course_store/actions';
import ModalRenewal from 'components/atoms/modal_renewal';
import OnboardingFirstBulletinModal from 'components/molecules/onboarding_first_bulletin';
import OurTools from 'components/molecules/our_tools';
import AmbassadorArea from 'components/molecules/ambassador_area';
import {
  getAllUnreadNotificationsCampaigns,
  getAllUnreadNotificationsDocuments,
  getAllUnreadNotificationsManagementBiddings,
  getAllUnreadNotificationsUpdatedBiddings,
} from 'store/modules/new_notification_store/actions';
import ModalRoboLances from 'components/atoms/modal_robo_lances';
import ModalNewRoboLances from 'components/atoms/modal_new_robo_lances';
import { hasCookie } from 'services/actions/cookies_actions';
import ConlicitasegModalFidelizeTester from 'components/molecules/conlicitaseg_modal_fidelize_tester';
// import ModalLive from 'components/atoms/modal_live';
import ConlicitasegOnlyPromoModal from 'components/molecules/conlicitaseg_only_promo_modal';
import useOnlyConlicitaseg from 'hooks/useOnlyConlicitaseg';
import InactiveDashboard from 'components/organisms/inactive_dashboard';
import { Container } from './styles';
import NewsSession from '../news_session';

const NewPanel = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const isOnlyConlicitaseg = useOnlyConlicitaseg();

  const [showModalBidWinner, setShowModalBidWinner] = useState<boolean>(panel?.bid_winner?.winner);
  const [showModalRenewal, setShowModalRenewal] = useState<boolean>(
    panel?.renewal_campaign?.released_online,
  );

  console.log(showModalBidWinner);

  useEffect(() => {
    const fetchData = async () => {
      document.title = 'Painel - ConLicitação';

      dispatch({ type: BiddingTypes.UPDATE_STORE_FIELDS });
      dispatch(biddingsOverview(companyId(profile)));
      dispatch(refreshProfile());
      dispatch({ type: ProfileTypes.UPDATE_STORE_FIELDS });
      dispatch(getFlashMessageNotifications());
      // dispatch(getTradingKeywords(companyId(profile)));
      dispatch(getUserContacts(companyId(profile)));
      dispatch(
        GetImmminence({
          stateImminence: 'has_imminence',
          page: 1,
          companyId: companyId(profile),
        }),
      );
      dispatch(getMonitoredElectronicTradingIds());
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!profile) return;

    dispatch(getAllUnreadNotificationsManagementBiddings({ read: 0 }));
    dispatch(getAllUnreadNotificationsCampaigns({ read: 0 }));
    dispatch(getAllUnreadNotificationsDocuments({ read: 0 }));
    dispatch(getAllUnreadNotificationsUpdatedBiddings({ read: 0 }));
  }, [dispatch, profile.id]);

  useEffect(() => {
    if (panel?.validate_services?.course_iaml || panel?.registration_type_validation === 1) {
      dispatch(getDataCourse(2));
      dispatch(getLastClass(2));
    }
  }, [panel?.validate_services?.course_iaml, panel?.registration_type_validation]);

  return (
    <>
      <Container className={`page-container px-3 ${profile.representant && 'representant-page'}`}>
        <div className="container-fluid big-resolutions">
          <div className="row">
            <div className="col-md-12 m-0">
              <FlashMessageNotification />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 m-0">
              <ExpirationAlert />
              {panel?.renewal_plans && (
                <BannerRenewalPanel campaign_phase={panel?.renewal_campaign?.campaign_phase} />
              )}
              {!isOnlyConlicitaseg && panel?.registration_type_validation === 1 && (
                <TopBannerInSample />
              )}
              {panel?.bid_winner?.winner && (
                <ModalBidWinner
                  setShowModal={setShowModalBidWinner}
                  showModalBidWinner={false}
                  edital={panel?.bid_winner?.edital}
                  orgao_nome={panel?.bid_winner?.orgao_nome}
                  contato_nome={panel?.bid_winner?.contato_nome}
                />
              )}
              {panel?.renewal_campaign?.released_online && panel?.renewal_campaign?.view_modal && (
                <ModalRenewal
                  setShowModal={setShowModalRenewal}
                  showModalRenewal={showModalRenewal}
                  contact_name={panel?.renewal_campaign?.contact_name}
                  campaign_phase={panel?.renewal_campaign?.campaign_phase}
                />
              )}
              {panel?.banner_robo_access && <ModalRoboLances />}
              {panel?.banner_new_robo_access && <ModalNewRoboLances />}
              {/* <ModalLive /> */}
            </div>
          </div>
          {(panel?.registration_type_validation === 1 || panel?.course_released) && (
            <div className="row mb-4">
              <div className="col-md-12">
                <IntroductionSession />
              </div>
            </div>
          )}
          {isOnlyConlicitaseg ? (
            <InactiveDashboard />
          ) : (
            <>
              {profile.ambassador?.member && (
                <div className="row mb-4">
                  <div className="col-md-12">
                    <AmbassadorArea />
                  </div>
                </div>
              )}
              <div className="row mb-4">
                <div className="col-md-12">
                  <OurTools />
                </div>
              </div>
              <div className="row mb-4">
                <div className="col-md-12">
                  <DashboardSession />
                </div>
              </div>
              <div className="row mb-4">
                <div className="col-md-12">
                  <NewsSession />
                </div>
              </div>
              <div className="row mb-4">
                <div className="col-md-12">
                  <OpportunitiesSession />
                </div>
              </div>
              <div className="row mb-4">
                <div className="col-md-12">
                  <ManagedBiddingsSession />
                </div>
              </div>
            </>
          )}
        </div>
        {panel?.registration_type_validation === 1 && <ModalWelcomeIaml />}
        <OnboardingFirstBulletinModal />
      </Container>
      <div className="row">
        <div className="col-md-12 mt-4">
          <EvaluationSession />
        </div>
      </div>
      {isOnlyConlicitaseg && <ConlicitasegOnlyPromoModal />}
      {!isOnlyConlicitaseg &&
        !hasCookie('ConlicitasegModalFidelizeTester') &&
        profile?.fidelize?.is_fidelize && <ConlicitasegModalFidelizeTester />}
    </>
  );
};
export default NewPanel;
